import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResourceArtifactHistoryModule } from './resource-artifact-history/resource-artifact-history.module';
import { ResourceBlueprintHistoryModule } from './resource-blueprint-history/resource-blueprint-history.module';
import { ResourceOverrideHistoryModule } from './resource-override-history/resource-override-history.module';
import {
  NbCardModule,
  NbIconModule,
  NbSelectModule,
  NbSpinnerModule,
} from '@nebular/theme';
import { ResourceHistoryComponent } from './resource-history.component';

@NgModule({
  declarations: [ResourceHistoryComponent],
  imports: [
    CommonModule,
    NbCardModule,
    NbIconModule,
    NbSelectModule,
    NbSpinnerModule,
    ResourceArtifactHistoryModule,
    ResourceBlueprintHistoryModule,
    ResourceOverrideHistoryModule,
  ],
  exports: [ResourceHistoryComponent],
})
export class ResourceHistoryModule {}
